var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShortLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 21,
    viewBox: "0 0 116 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55132 0.390152H12.5174C13.5565 0.390152 14.4752 0.568138 15.2738 0.92411C16.0723 1.28008 16.741 1.74669 17.2797 2.32395C17.8281 2.89158 18.2418 3.53137 18.5208 4.24331C18.8095 4.95525 18.9538 5.67201 18.9538 6.39357C18.9538 7.15362 18.8095 7.89924 18.5208 8.63043C18.2418 9.35199 17.8281 9.99659 17.2797 10.5642C16.7313 11.1222 16.0579 11.5744 15.2594 11.9208C14.4608 12.2575 13.5468 12.4259 12.5174 12.4259H7.95711V20.5218H4.55132V0.390152ZM7.95711 9.56846H11.7958C12.4982 9.56846 13.085 9.48668 13.5565 9.32313C14.0375 9.14995 14.4223 8.91905 14.711 8.63043C15.0092 8.3418 15.2209 8.00507 15.3459 7.62023C15.4806 7.22578 15.548 6.80246 15.548 6.35028C15.548 5.90772 15.4662 5.49883 15.3026 5.12362C15.1391 4.73878 14.8986 4.41168 14.5811 4.14229C14.2636 3.86329 13.8691 3.64682 13.3977 3.49288C12.9359 3.33895 12.402 3.26198 11.7958 3.26198H7.95711V9.56846Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.37256,
    width: 3.65705,
    height: 9.6197,
    fill: "#3355D1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    x: 4.66412,
    y: 3.32541,
    width: 3.10054,
    height: 3.72412,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 1.56342,
    y: 7.64267,
    width: 3.10054,
    height: 1.90985,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 3.10054,
    height: 1.90911,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogoWhite);
export default __webpack_public_path__ + "static/media/short_logo_white.2e0cf4ef33bf8528f9cfcb9cfac790c0.svg";
export { ForwardRef as ReactComponent };